<div class="flex flex-col justify-center items-center">
  <h1 class="font-bold paragraph-large mb-4 sm:mb-6">{{ 'buildYourNetwork.sendReminder' | translate }}</h1>
  <nz-tag class="flex justify-start items-center remind p-4 mb-6 sm:mb-8" nzMode="closeable">
    <div class="flex items-center gap-2 sm:gap-4 sm:pr-7">
      <i nz-icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2C17.523 2 22 6.478 22 12C22 17.522 17.523 22 12 22C6.477 22 2 17.522 2 12C2 6.478 6.477 2 12 2ZM12.0018 15.0037C11.4503 15.0037 11.0031 15.4508 11.0031 16.0024C11.0031 16.5539 11.4503 17.001 12.0018 17.001C12.5533 17.001 13.0005 16.5539 13.0005 16.0024C13.0005 15.4508 12.5533 15.0037 12.0018 15.0037ZM11.9996 7C11.4868 7.00018 11.0643 7.38638 11.0067 7.88374L11 8.00036L11.0018 13.0012L11.0086 13.1179C11.0665 13.6152 11.4893 14.0011 12.0022 14.0009C12.515 14.0007 12.9375 13.6145 12.9951 13.1171L13.0018 13.0005L13 7.99964L12.9932 7.88302C12.9353 7.3857 12.5125 6.99982 11.9996 7Z"
            fill="#222528"
          />
        </svg>
      </i>
      @if (reminderCount === 0) {
        <span class="paragraph-small-card outfit regular">
          {{ 'buildYourNetwork.firstReminderAlert' | translate }}
        </span>
      }
      @if (reminderCount === 1) {
        <span class="paragraph-small-card outfit regular">
          {{ 'buildYourNetwork.secondReminderAlert' | translate }}
        </span>
      }
      @if (reminderCount === 2) {
        <span class="paragraph-small-card outfit regular">
          {{ 'buildYourNetwork.ThirdReminderAlert' | translate }}
        </span>
      }
    </div>
  </nz-tag>
  <div class="w-full mb-4">
    <span class="paragraph-medium medium mb-2 block">{{ 'referral.contact-method' | translate }}</span>
    <nz-radio-group [formControl]="contactMethodControl">
      <div class="flex gap-6 items-center flex-wrap">
        <label nz-radio nzValue="whatsapp">{{ 'referral.whatsApp' | translate }}</label>
        <label nz-radio nzValue="email">{{ 'profile.email' | translate }}</label>
      </div>
    </nz-radio-group>
  </div>
  <div class="w-full mb-6">
    @if (contactMethodControl?.value === 'email') {
      <korviu-input
        type="text"
        label="{{ 'auth.email' | translate }}"
        [showErrorMessagesUnderField]="true"
        [errorMessagesUnderField]="[{ errorCode: 'email', localizedMessage: 'validation.invalidEmail' }]"
        [control]="emailControl"
      ></korviu-input>
    } @else {
      <korviu-input
        type="phone"
        label="{{ 'referral.phoneNumber' | translate }}"
        maxLength="14"
        class="phone-number-field"
        [control]="phoneNumberControl"
        [phoneNumberPrefixControl]="phoneNumberPrefixControl"
        [removePlusFromPhoneCode]="true"
        [showErrorMessagesUnderField]="true"
        [errorMessagesUnderField]="[
          { errorCode: 'pattern', localizedMessage: 'validation.invalidPhoneNumber' },
          { errorCode: 'minlength', localizedMessage: 'validation.invalidPhoneNumber' }
        ]"
        (input)="onPhoneNumberInput($event)"
      />
    }
  </div>
  <div class="w-full mb-6">
    <span class="paragraph-medium medium mb-2 block">{{ 'referral.language' | translate }}</span>
    <nz-radio-group [formControl]="messageLanguageControl">
      <div class="flex gap-6 items-center flex-wrap">
        <label nz-radio nzValue="es">{{ 'common.spanish' | translate }}</label>
        <label nz-radio nzValue="en">{{ 'common.english' | translate }}</label>
      </div>
    </nz-radio-group>
  </div>
  <div class="w-full template-message">
    <nz-skeleton [nzLoading]="isLoading" [nzTitle]="false" [nzParagraph]="{ rows: 3 }" [nzActive]="true">
      <korviu-textarea
        [control]="messageControl"
        [spellcheck]="false"
        customClass="reminder-message-textarea"
      ></korviu-textarea>
    </nz-skeleton>
  </div>
  <div *nzModalFooter class="modal-footer">
    <div class="flex gap-4 w-full">
      <korviu-button color="ghost" (click)="cancel()" class="w-full">{{ 'common.cancel' | translate }}</korviu-button>
      <korviu-button color="tertiary" [disabled]="isSendDisabled" (click)="send()" class="w-full">
        {{ 'common.send' | translate }}
      </korviu-button>
    </div>
  </div>
</div>
